import { useCallback } from "react";
import { VocabularyProgress } from "../utils/vocabularyProgressStorage";
import { useDeviceProgress } from "./useDeviceProgress";

export function useVocabularyProgress() {
    const { data: progress, update, syncStatus } = useDeviceProgress<VocabularyProgress>("vocabularyProgress");
    const setLearned = useCallback((key: string, learned: boolean) => {
        return update(learned ? { kind: "set", key, value: "learned" } : { kind: "remove", key });
    }, [update]);
    return { progress, setLearned, syncStatus };
}
